<template>
  <div class="box">
    <div class="title_box flex">

      <div class="title_item" :class="placard.apply_for_invoice_title == '1' ? 'activeTab' : ''"
           @click="TitleShow('1')">
        申请发票
      </div>
      <div class="title_item" :class="placard.apply_for_invoice_title == '2' ? 'activeTab' : ''"
           @click="TitleShow('2')">
        我的开票资料
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
  components: {},
  computed: {
    ...mapState(['placard']),
    ...mapMutations(['SET_DATA'])
  },
  mounted() {
  },
  data() {
    return {}
  },
  methods: {
    TitleShow(index) {
      this.$store.commit('SET_DATA', {
        form: 'apply_for_invoice_title',
        value: index
      })
      console.log(this.placard.apply_for_invoice_title);
      if (this.placard.apply_for_invoice_title == '1') {
        this.$router.push({
          path: '/placard_user/placard_apply_for_invoice/placard_apply_for_invoice_data',
        })
      } else {
        this.$router.push({
          path: '/placard_user/placard_apply_for_invoice/placard_apply_for_invoice_list',
        })
      }
    },
    // 跳转添加开票资源
    goAddInvoice() {
      this.$router.push({
        path: '/user/AddInvoice'
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@use '@/scss/ApplyForInvoice';
</style>